export const DEFAULT_PRICING = {
  packages: [
    {
      key: "essenziale",
      name: "Essential",
      price: 220,
      tagline: "La soluzione professionale per presentare un immobile in modo completo",
      featured: false,
      features: ["20 fotografie professionali", "Shooting di interni ed esterni", "Selezione e post-produzione professionale", "Correzione prospettica", "Ottimizzazione di luce e colore", "File pronti per portali, sito e social", "Diritti di utilizzo inclusi"],
    },
    {
      key: "signature",
      name: "Signature",
      price: 390,
      tagline: "Il più scelto da host e B&B",
      featured: true,
      features: ["35 fotografie professionali", "Shooting completo di interni ed esterni", "Selezione e post-produzione professionale", "Fotografie aeree professionali", "Valorizzazione degli esterni e del contesto", "Consegna in 48 ore", "2 round di revisione", "Ottimizzazione per Airbnb, Booking, sito e social", "Diritti di utilizzo inclusi"],
    },
    {
      key: "premium",
      name: "Premium",
      price: 790,
      tagline: "La soluzione completa per ville, strutture di pregio e presentazioni su più canali",
      featured: false,
      features: ["45 fotografie professionali", "Shooting completo di interni ed esterni", "Selezione e post-produzione professionale", "Fotografie aeree professionali", "Video aereo professionale montato", "Tour immersivo 3D incluso fino a 150 m² — oltre, supplemento in base alla metratura", "🎁 Reel verticale da 30 secondi in omaggio", "Consegna in 48 ore", "Revisioni illimitate", "Diritti di utilizzo inclusi"],
    },
  ],
  photo_packs: [
    { key: "pack-5", qty: 5, price: 40 },
    { key: "pack-10", qty: 10, price: 70 },
    { key: "pack-20", qty: 20, price: 120 },
  ],
  extras: [
    { key: "aerei", name: "Contenuti Aerei", price: 150, desc: "Immagini e video dall'alto per mostrare la proprietà nel suo insieme e il rapporto con ciò che la circonda: esterni, panorama, posizione" },
    { key: "ora-d-oro", name: "Scatti all'ora d'oro", price: 60, desc: "La magia del tramonto su esterni e terrazze" },
    { key: "virtual-tour", name: "Tour immersivo 3D", price: 220, desc: "Esplora la struttura prima ancora di arrivare: un modello 3D navigabile per muoversi tra gli ambienti, comprenderne la disposizione e osservare la proprietà nel suo insieme" },
    { key: "stagionale", name: "Seasonal Refresh", price: 120, desc: "Per chi ha già uno shooting completo e vuole rinnovare l'immagine della proprietà — fino a 15 foto. Non è un nuovo shooting completo" },
  ],
};

// Servizi specialistici: i delta si sommano al prezzo base a listino (allineati al backend).
// delta null = servizio quotato su preventivo.
export const AERIAL_OPTIONS = [
  { key: "foto", delta: 0 },
  { key: "video", delta: 100 },
  { key: "combo", delta: 200 },
];

// Signature include già le fotografie aeree: il completamento video costa base+50 = €200
export const SIGNATURE_AERIAL_VIDEO_DELTA = 50;

export const TOUR3D_BANDS = [
  { key: "fino-80", delta: 0 },
  { key: "81-150", delta: 80 },
  { key: "151-250", delta: 180 },
  { key: "251-400", delta: 280 },
  { key: "oltre-400", delta: null },
];

// Tour 3D incluso nel Premium fino a 150 m²: oltre, supplemento.
export const PREMIUM_SURFACE = [
  { key: "fino-80", surcharge: 0 },
  { key: "81-150", surcharge: 0 },
  { key: "151-250", surcharge: 100 },
  { key: "251-400", surcharge: 200 },
  { key: "oltre-400", surcharge: null },
];
